import React from 'react';
import './App.css';
import VideoBackground from './VideoBackground';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok, faPatreon, faYoutube, faFacebook, faApple } from '@fortawesome/free-brands-svg-icons';

function App() {
  return (
    <div className="App">
      <VideoBackground />
      <br />
      <div className="content-section container" style={{ textAlign: 'center' }}>
        <h1>Bio</h1>
        {/* <p>Zoranine, an electronic music project by producer David Aaron Campos, emerges as a captivating force embodying the essence of atmospheric synthesis, glitchies, and more fvckery. Known for its ethereal yet tangible soundscapes, Zoranine's music is an immersive experience, a journey through emotional extremes. Each composition intertwines somber tones with whispers of hope and playful intrigue, creating a mesmerizing balance of darkness and light. This project seeks to unravel the boundaries & complexities of the emotional human experience.</p> */}
        <p>Zoranine is an electronic music project by independent artist & producer David Aaron Campos.</p>
        <p>From his beginnings as an abstract painter and heavy metal drummer in Tijuana, Mexico, David’s artistic expression has extended to playing piano & synthesizers, sampling, composition, and music production.</p>
        <p>Now based in New York City, Zoranine’s music is heavily influenced by legendary musicians & experimentalists like Frédéric Chopin, Erik Satie, Hans Zimmer, Nils Frahm, Flume and Odesza.</p>
        <p>Zoranine’s music is shaped by atmospheric synthesis, glitchies, and more fvckery. Known for its ethereal and immersive soundscapes, Zoranine's music is a journey through emotional extremes. Each track blurs the lines between hope & despair, darkness and light. This project seeks to unravel the boundaries & complexities of the human condition.</p>
      </div>

      <div className="content-section container" style={{ textAlign: 'center' }}>
        <h1>Music</h1>
        <iframe
          style={{ borderRadius: '12px' }}
          src="https://open.spotify.com/embed/artist/18WES91kCe4F5XAxqAsH9W?utm_source=generator&theme=0"
          width="100%"
          height="420"
          frameBorder="0"
          allowFullScreen={true}
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
          title="Spotify Embed">
        </iframe>
      </div>

      <br/>
      <br/>
      <br/>

      {/* Social Media Icons */}

      <div className="social-media-links" style={{ textAlign: 'center', marginTop: '20px' }}>
        <a href="https://instagram.com/zoraninemusic" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faInstagram} size="2x" style={{ color: 'black' }} />
        </a>{' '}
        <a href="https://www.tiktok.com/@zoraninemusic" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faTiktok} size="2x" style={{ color: 'black' }} />
        </a>{' '}
        <a href="https://www.patreon.com/Zoranine" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faPatreon} size="2x" style={{ color: 'black' }} />
        </a>{' '}
        <a href="https://www.youtube.com/@ZoranineOfficial" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faYoutube} size="2x" style={{ color: 'black' }} />
        </a>{' '}
        <a href="https://music.apple.com/us/artist/zoranine/1682783601" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faApple} size="2x" style={{ color: 'black' }} />
        </a>{' '}
        {/* <a href="https://facebook.com/yourusername" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
          <FontAwesomeIcon icon={faFacebook} size="2x" style={{ color: 'black' }} />
        </a> */}
      </div>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  );
}

export default App;
